import { seabookRouteMap } from '@dfds-pax/utils'

type SurveyBasket = {
  id: string
  sessionId: string
  initialOfferCode: string | null
  passengers: Array<{
    categoryCode: string
  }>
  departures: Array<{
    arrivalPort: string
    departureDate: string
    departurePort: string
    pets: Array<{
      quantity: number
    }>
  }>
  vehicle?: {
    trailerTypeCode?: string
    vehicleTypeCode: string
  }
}

export type SurveyCustomerData = {
  basketId: string
  sessionId: string
  initialParameters: {
    route: string | null
    vehicle: string | null
    trailer: string | null
    adults: number
    children: number
    infants: number
    pets: number
    outboundDate: string | null
    returnDate: string | null
    offerCode: string | null
  }
}

export function saveSurveyBasketData(basket: SurveyBasket): void {
  const outboundDeparture = basket.departures[0]
  const returnDeparture = basket.departures[1]
  const route = outboundDeparture
    ? (seabookRouteMap.find((item) => item.route === `${outboundDeparture.departurePort}-${outboundDeparture.arrivalPort}`)?.seabook ??
      null)
    : null

  const surveyCustomerData: SurveyCustomerData = {
    basketId: basket.id,
    initialParameters: {
      adults: basket.passengers.filter((passenger) => passenger.categoryCode.toUpperCase() === 'ADULT').length,
      children: basket.passengers.filter((passenger) => passenger.categoryCode.toUpperCase() === 'CHILD').length,
      infants: basket.passengers.filter((passenger) => passenger.categoryCode.toUpperCase() === 'INFANT').length,
      offerCode: basket.initialOfferCode,
      outboundDate: outboundDeparture?.departureDate ?? null,
      pets: outboundDeparture?.pets.reduce((total, pet) => total + pet.quantity, 0) ?? 0,
      returnDate: returnDeparture?.departureDate ?? null,
      route,
      trailer: basket.vehicle?.trailerTypeCode ?? null,
      vehicle: basket.vehicle?.vehicleTypeCode ?? null,
    },
    sessionId: basket.sessionId,
  }

  sessionStorage.setItem('survey-basket-data', JSON.stringify(surveyCustomerData))
}
